import React, { useEffect, useState } from "react";
import { Checkbox, Form, message } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { updateDataReq } from "../requests";
import { Commons, Const, Validations } from "../../../constants";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { masterTooltips } from "../../../../common/masterTooltips";
const langKey = Const["documentType"].lngKey
const fieldLabel = makeFieldLabel(masterTooltips.lookup, { namespace: "lookup", label: (key) => trans(`${langKey}.${key}`) });
const formName = "updateDocumentType";

const UpdateDocumentType = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [form] = Form.useForm();
  useEffect(() => {
    setFormData();
  }, []);

  const setFormData = () => {
    if (!props) {
      return;
    }
    form.setFieldsValue(props.record);
  }
  const onSubmit = (data) => {
    setSaveLoader(true)
    data.id = props.record.id;
    const payload = { document_type: data };
    payload.id = props.record.id;
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Record Updated");
    props.onCompleted(data.document_types.data);
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    !props.disabled &&
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) } disabled={ props.disabled }>

      <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } disabled={ props.disabled } scrollToFirstError>

        <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(Commons.name)) }
          className="da-mb-16"
          { ...getErrorProps(errors['name']) } size="small"
        >
          <InputText placeholder={ trans(`${langKey}.name`) } />
        </Form.Item>

        <Form.Item name="is_required" valuePropName="checked" rules={ rules.is_required } label={ fieldLabel("is_required", trans(`${langKey}.required`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_required']) } size="small"
        >
          <Checkbox />
        </Form.Item>
        <Form.Item name="is_expiry" valuePropName="checked" rules={ rules.is_expiry } label={ fieldLabel("is_expiry", trans(`${langKey}.expiry`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_expiry']) } size="small"
        >
          <Checkbox />
        </Form.Item>
        <Form.Item name="is_multi_attachments" valuePropName="checked" rules={ rules.is_multi_attachments } label={ fieldLabel("is_multi_attachments", trans(`${langKey}.multiple`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_multi_attachments']) } size="small"
        >
          <Checkbox />
        </Form.Item>
        <Form.Item name="is_additional_info" valuePropName="checked" rules={ rules.is_additional_info } label={ fieldLabel("is_additional_info", trans(`${langKey}.additional`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_additional_info']) } size="small"
        >
          <Checkbox />
        </Form.Item>


      </Form>
    </ModalComponent>
  )
}

export default UpdateDocumentType

const rules = {
  name: [
    { required: true, message: trans(Validations.name) },
  ],

};

const formLayout = {
  // layout: "horizontal",
  labelCol: { span: 6 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}